// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"bfbc9a8d97553fe6","2013":"8cb35cbb04bc04c2","3807":"4874e4271221d1da","9099":"320428ae2ad86c47"}[chunkId] + ".js";
};